var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    enableBackground: "new 0 0 68 68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 68,
    height: 68,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAilBMVEUAAADnUFDsUFDtUFDv UlLvUVHvUVHvUVHqUFDfUFDvUlLuUVHrUFDtUlLuUlLvUlLuUVHuUVHvU1PtUFDvU1PvUFDtUFDu UVHtUFDtUFDuUFD3UlLuUFDuUFDvUFDvUFDtUFDvUFDuUVHvXFzyfHzxcnLzh4f+9PT////96enw Z2f709PvW1v71NSmyd47AAAAInRSTlMAIGCPr9/PvzAQn+9An69/z99fcG8QgL+fkK8fsN8gMKCv uHHdhgAAAAFiS0dEKL2wtbIAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfmARERGxfuDcxv AAACI0lEQVRYw7XYfX+aMBAH8Bh1UrEW2iFja7E7UYNu7//tLeiKmlzuLtT+/ozy/eSBcAGlghnp 8WQ6BZvpt9lYJyo2D3qegpN0oh8iiMXYE/7nUdqfxQyIzBYCIiGJLssRNxdPHNHliTRGmcQAyInO PKcyw67US8gQDYUZUpQRUCINVIk2EOV7vAHw7KyteF2uk96udD7EAMiKz03IOaurwQw1AC67ejIc Kfu97/6yaRr8km2zcZs+ngzu5t/tjWkPPnE42vYd3pXE7UdrDKYcTu37P2hXfjitjTGYcjaMcUda dUbhDdxgyofhIWl3r2hv7H8RpTda7+/aIj/9CWw9BWnqM7cIsmu8SygDUn9tsItIA+AXMiXeZYxh J6UCTuEMu8ihWnW5lDPgVQUrTa9wBuTqDWRK2LAIgEghDAAKuVJI4+sR+XDuMrFvMoNSMmQTOwZ/ s5X3ue01Z0g2YM0arLK+z0NJvfMGrbyiD2rsgl45IlNiS4Y7noYuGVsXOR0vKhyRFq85Ws83e6qM tm4ZXZ+Lcek07+y/j1hBt+37QEHHjhZbQNOEjxZeVyKy7E9KyXCkvhzaVkONq4OfKoSvKG7ym3Ns PewwXN8ggScCE++lZ8C0rJT6tIIY0QpqRCoBQ6kX+YukVsHUwleWrFZURENaFYpO/ZsjyrXisyA3 dSn54NAleQ8IaSUluhR66X+EedTcXCD90VWZnZYrz5eVJr4x/AMnAe4fsSg1ggAAACV0RVh0ZGF0 ZTpjcmVhdGUAMjAyMi0wMS0xN1QxNzoyNzoyMyswMDowMKZwRGoAAAAldEVYdGRhdGU6bW9kaWZ5 ADIwMjItMDEtMTdUMTc6Mjc6MjMrMDA6MDDXLfzWAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseError);
export default __webpack_public_path__ + "static/media/close-error.df560203.svg";
export { ForwardRef as ReactComponent };